(function($) {
	'use strict';

	/**
	 * Populate control sets from data
	 * 
	 * This function extracts unique control UIDs for all standards and organizes
	 * them into a normalized control sets object. It normalizes standard IDs
	 * while retaining parentheses for proper key formatting.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @returns {Object} Object containing control sets organized by normalized standard IDs
	 */
	function populateControlSets(data) {
		const allControlUIDs = WebAssessmentCharts.extractUniqueControlUIDsForAllStandards(data);

		const controlSets = {};
		Object.keys(allControlUIDs).forEach(standardID => {
			// Normalize the standard ID but retain parentheses
			const normalizedKey = standardID.replace(/[^\w()]+/g, '_'); // Keep alphanumeric and parentheses
			controlSets[normalizedKey] = allControlUIDs[standardID];
		});
		//console.log('controlSets inside populateControlSets', controlSets);
		return controlSets;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { populateControlSets };
	} else if (typeof window !== 'undefined') {
		window.populateControlSets = populateControlSets;
	}

})(jQuery);
